import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';

const AdminSidebar = ({ mobile }) => {
  const location = useLocation();
  const { logoutAdmin, currentAdmin } = useAdmin();

  // Admin navigation items
  const adminNavigation = [
    { name: 'Dashboard', href: '/admin/dashboard', icon: '📊' },
    { name: 'User Management', href: '/admin/users', icon: '👥' },
    ...(currentAdmin?.role === 'superadmin' ? [{ name: 'Admin Management', href: '/admin/admins', icon: '🔑' }] : []),
    { name: 'System Settings', href: '/admin/settings', icon: '⚙️' },
  ];

  return (
    <aside className={`app-sidebar ${mobile ? 'mobile' : 'desktop'}`}>
      <div className="sidebar-header">
        <h1 className="sidebar-title">Admin Panel</h1>
      </div>
      
      <nav className="sidebar-nav">
        <ul className="nav-list">
          {adminNavigation.map((item) => (
            <li key={item.name} className="nav-item">
              <Link
                to={item.href}
                className={`nav-link ${location.pathname === item.href ? 'active' : ''}`}
              >
                <span className="nav-icon">{item.icon}</span>
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      
      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-details">
            <div className="user-name">{currentAdmin?.name || 'Admin'}</div>
            <div className="user-email text-smd mt-2">{currentAdmin?.email || 'admin@example.com'}</div>
          </div>
        </div>
        <div className="account-actions text-smd">
          <Link
            to="/admin/change-password"
            className={`nav-link ${location.pathname === '/admin/change-password' ? 'active' : ''}`}
          >
            <span className="nav-icon">🔒</span>
            Change Password
          </Link>
          <button onClick={logoutAdmin} className="logout-button text-smd">
            <span className="nav-icon">🚪</span>
            Logout
          </button>
        </div>
      </div>
    </aside>
  );
};

export default AdminSidebar; 